(function () {
  if (window.__megaMenuLazyInit) return;
  window.__megaMenuLazyInit = true;

  const SECTION_ID = 'mega-menu-collection';

  function normalizeKey(str) {
    return (str || '').toLowerCase().replace(/\s+/g, '');
  }

  function parseMegaMenuCollectionHtml(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const section = doc.getElementById(`shopify-section-${SECTION_ID}`);
    const root = section || doc;
    const collection = root.querySelector('.mega-menu__product-collection');
    return collection ? collection.outerHTML : '';
  }

  function loadMegaMenuCollection(container) {
    if (!container || container.dataset.loaded === 'true') {
      return Promise.resolve();
    }

    if (container._megaMenuLoadPromise) {
      return container._megaMenuLoadPromise;
    }

    const handle = container.dataset.collection;
    if (!handle) {
      return Promise.resolve();
    }

    const limit = container.dataset.limit || '6';
    container.classList.add('is-loading');
    container.setAttribute('aria-busy', 'true');

    const url = new URL(
      `${window.Shopify.routes.root}collections/${encodeURIComponent(handle)}`,
      window.location.origin
    );
    url.searchParams.set('section_id', SECTION_ID);
    url.searchParams.set('limit', limit);

    container._megaMenuLoadPromise = fetch(url.toString(), { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Mega menu section request failed: ${response.status}`);
        }
        return response.text();
      })
      .then((html) => {
        const nextHtml = parseMegaMenuCollectionHtml(html);
        if (nextHtml) {
          container.outerHTML = nextHtml;
          return;
        }

        container.classList.remove('is-loading');
        container.dataset.loaded = 'true';
        container.innerHTML =
          '<p class="mega-menu__product-collection-empty">No products available</p>';
      })
      .catch(() => {
        container.classList.remove('is-loading');
        container.dataset.loaded = 'true';
        container.innerHTML =
          '<p class="mega-menu__product-collection-empty">Unable to load products</p>';
      })
      .finally(() => {
        container.removeAttribute('aria-busy');
        delete container._megaMenuLoadPromise;
      });

    return container._megaMenuLoadPromise;
  }

  function getLazyCollectionContainer(scope) {
    if (!scope) return null;

    const activeGroup = scope.querySelector('.mega-menu__product-group.is-active');
    if (activeGroup) {
      return activeGroup.querySelector('.mega-menu__product-collection--lazy[data-loaded="false"]');
    }

    return scope.querySelector('.mega-menu__product-collection--lazy[data-loaded="false"]');
  }

  function loadVisibleMegaMenuProducts(megaMenu) {
    const activeBelow = megaMenu?.querySelector('.mega-menu__grid--below.is-active');
    if (!activeBelow) return Promise.resolve();

    const container = getLazyCollectionContainer(activeBelow);
    if (!container) return Promise.resolve();

    return loadMegaMenuCollection(container);
  }

  function activateLevel2(link, options) {
    const load = !options || options.load !== false;
    const key = link.dataset.key;
    const megaMenu = link.closest('.mega-menu__content');
    if (!megaMenu) return;

    megaMenu
      .querySelectorAll('.mega-menu__link--level-2')
      .forEach((item) => item.classList.remove('is-active-2-link'));
    link.classList.add('is-active-2-link');

    megaMenu
      .querySelectorAll('.mega-menu__grid--below')
      .forEach((panel) => panel.classList.remove('is-active'));

    const activeBelow = megaMenu.querySelector(
      `.mega-menu__grid--below[data-key="${CSS.escape(key)}"]`
    );
    if (activeBelow) {
      activeBelow.classList.add('is-active');
    }

    megaMenu.querySelectorAll('.mega-menu__list-3').forEach((list) => {
      list.classList.remove('is-active-3');
    });

    const level3List = megaMenu.querySelector(
      `.mega-menu__list-3[data-key="${CSS.escape(key)}"]`
    );

    if (level3List) {
      level3List.classList.add('is-active-3');

      const firstLevel3 = level3List.querySelector('.mega-menu__link--level-3[data-subkey]');
      if (firstLevel3) {
        activateProductGroup(megaMenu, firstLevel3.dataset.subkey, load);
        return;
      }
    }

    if (load) {
      loadVisibleMegaMenuProducts(megaMenu);
    }
  }

  function activateProductGroup(megaMenu, subKey, load) {
    const shouldLoad = load !== false;
    const activeBelow = megaMenu.querySelector('.mega-menu__grid--below.is-active');
    if (!activeBelow) return;

    const normalizedSubKey = normalizeKey(subKey);
    const groups = activeBelow.querySelectorAll('.mega-menu__product-group');

    groups.forEach((group) => group.classList.remove('is-active'));

    for (const group of groups) {
      if (normalizeKey(group.dataset.key) === normalizedSubKey) {
        group.classList.add('is-active');
        break;
      }
    }

    const level3Links = megaMenu.querySelectorAll('.mega-menu__link--level-3[data-subkey]');
    level3Links.forEach((link) => link.classList.remove('is-active-3-link'));

    for (const link of level3Links) {
      if (normalizeKey(link.dataset.subkey) === normalizedSubKey) {
        link.classList.add('is-active-3-link');
        break;
      }
    }

    if (shouldLoad) {
      loadVisibleMegaMenuProducts(megaMenu);
    }
  }

  function initMegaMenu() {
    document.querySelectorAll('.mega-menu__link--level-2[data-key]').forEach((link) => {
      link.addEventListener('mouseenter', function () {
        activateLevel2(this);
      });
    });

    document.querySelectorAll('.mega-menu__link--level-3[data-subkey]').forEach((link) => {
      link.addEventListener('mouseenter', function () {
        const megaMenu = this.closest('.mega-menu__content');
        if (!megaMenu) return;
        activateProductGroup(megaMenu, this.dataset.subkey);
      });
    });

    document.querySelectorAll('details.mega-menu').forEach((details) => {
      details.addEventListener('toggle', function () {
        if (!this.open) return;
        const megaMenu = this.querySelector('.mega-menu__content');
        loadVisibleMegaMenuProducts(megaMenu);
      });
    });

    document.querySelectorAll('.mega-menu__content').forEach((menu) => {
      const firstLevel2 = menu.querySelector('.mega-menu__link--level-2[data-key]');
      if (firstLevel2) {
        activateLevel2(firstLevel2, { load: false });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }
})();
